export type TelegramUser = { id: number; first_name: string; username?: string; photo_url?: string };

type TelegramWebApp = {
  initData: string;
  initDataUnsafe?: { user?: TelegramUser; start_param?: string };
  BackButton?: { show(): void; hide(): void; onClick(callback: () => void): void; offClick(callback: () => void): void };
  colorScheme?: "light" | "dark";
  version?: string;
  isFullscreen?: boolean;
  ready(): void;
  expand(): void;
  requestFullscreen?(): void;
  disableVerticalSwipes?(): void;
  openTelegramLink?(url: string): void;
  openLink?(url: string): void;
  downloadFile?(params: { url: string; file_name: string }, callback?: (accepted: boolean) => void): void;
};

declare global { interface Window { Telegram?: { WebApp?: TelegramWebApp } } }

export function getTelegramWebApp() { return window.Telegram?.WebApp; }
